import { render, staticRenderFns } from "./BForgotPassword.vue?vue&type=template&id=08d194e0"
import script from "./BForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./BForgotPassword.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports